module.exports = __webpack_public_path__ + "img/inst.61bdf647.svg";